// Hızlı Satış terminali tema tercihi (açık/koyu) — yalnız terminal açıkken <html>.dark uygulanır, kapanınca kaldırılır
const KEY = "ge_pos_theme";
export const getPosTheme = () => { try { return localStorage.getItem(KEY) === "dark" ? "dark" : "light"; } catch { return "light"; } };
export const setPosTheme = (t) => { try { localStorage.setItem(KEY, t); } catch { /* depolama yok */ } };
export const applyPosTheme = (theme, active) => {
  const el = document.documentElement;
  if (active && theme === "dark") el.classList.add("dark"); else el.classList.remove("dark");
};
